import React, { useEffect, useState } from 'react';
import Preloader from '../elements/Preloader';
import HelmetReact from '../elements/HelmetReact';
import HeaderThree from '../components/HeaderThree';
import Breadcrumb from '../components/Breadcrumb';
import FooterThree from '../components/FooterThree';
import Newsletter from '../components/Newsletter';
import PricingInner from '../components/PricingInner';
import FaqOne from '../components/FaqOne';

const Pricing = () => {
    let [active, setActive] = useState(true);
    useEffect(() => {
        setTimeout(function() {
            setActive(false);
        }, 500);
    }, []);
    return (
        <>
            {/* Preloader */}
            {active === true && <Preloader/>}

            {/* Helmet */}
            <HelmetReact title={'获取报价'}/>

            {/* HeaderThree */}
            <HeaderThree/>

            {/* Breadcrumb */}
            <Breadcrumb title="获取报价"/>

            {/* PricingInner */}
            <PricingInner/>

            {/* FaqOne */}
            <div className="space-bottom faq-single">
                <FaqOne/>
            </div>

            {/* Newsletter */}
            {/*<Newsletter />*/}

            {/* FooterThree */}
            <FooterThree/>

        </>
    );
};

export default Pricing;
